module.exports = __webpack_public_path__ + "92233a74be2e510575a3bccb30e26d94.jpg";